<template lang="pug">
v-navigation-drawer.g-navigation-drawer(
  temporary,
  width="355",
  :src="require('@/assets/backsky.png')"
  dark,
  color="primary"
  @input="$emit('input', $event)"
  v-bind="{ app, value }"
 )
  v-layout(column fill-height)
    v-list.py-0(dense)
      v-list-item.title__logo.justify-center
        v-icon.logo $geodis
        v-icon.title__close(@click="$emit('input', false)") mdi-close
      template(v-for="category in data")
        template(v-if="!category.children")
          v-list-item.category.px-10(
            active-class="g-group--is-active"
            @mousedown="setPortal({})"
            :to="category.url",
            exact,
            link,
          )
            v-list-item-icon
              v-icon {{category.icon}}
            v-list-item-title {{category.name}}
        template(v-else)
          v-list-group.g-group.category(
            :prepend-icon="category.icon",
            active-class="g-group--is-active",
            eager
          )
            template(v-slot:activator="")
              v-list-item-title {{category.name}}
            template(v-for="child in category.children")
              v-list-item.grouped(
                @mousedown="setPortal(child)"
                :to="child.url",
                link,
                active-class="g-list-item--is-active"
              )
                v-list-item-icon.justify-center.align-center
                  v-icon(size="8") mdi-checkbox-blank-circle
                v-list-item-title {{child.name}}
    v-spacer
    v-list.px-0(dense)
      v-icon.vector-lines $vectorLines
      v-list-item(v-if="showBack", link, @click="$emit('back')")
        v-list-item-icon
          v-icon mdi-arrow-left
        v-list-item-title
      v-list-item.px-2.text-center
        v-list-item-title {{formattedVersion}}
</template>

<script>
export default {
  name: 'GNavigationDrawer',
  props: {
    app: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Array,
      default: () => ([]),
    },
    version: {
      type: String,
      default: '1.0.0',
    },
    showBack: {
      type: Boolean,
      default: true,
    },
    value: null,
  },
  data: () => ({}),
  methods: {
    setPortal(category) {
      // Only set when category has a portal property, this one is unset in the
      // router.beforeEach, to know more about how the portal property is set
      // check Sidebar.vue:createMenuPortals.
      if (category.portal) {
        this.$store.commit('SET_PORTAL_TEMPLATE', category.portal);
      }
    },
  },
  computed: {
    formattedVersion () {
      return `Version ${this.version || ''}`;
    },
  },
};
</script>

<style lang="scss">
@import "NavigationDrawer.scss";
</style>
